import React from "react";
import classes from "./LogoWall.module.css";
import Container from "../../UI/Container/Container";
import Logos from "./Logos";
import Logo from "./Logo/Logo";

const LogoWall = (props) => {
  const logoArr = Logos.map((logo, index) => {
    return <Logo image={logo.image} key={index} alt={logo.title} />;
  });

  return (
    <div className={classes.LogoWall}>
      <Container>
        <h2>Dickinsonians secure positions at top companies</h2>
        <div className={classes.LogoGrid}>{logoArr}</div>
      </Container>
    </div>
  );
};

export default LogoWall;
